import { Component, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { HttpService } from 'src/app/http.service';
import { HttpClient } from '@angular/common/http';

function ValidateEmail(control:AbstractControl):{[key:string]:Boolean}|null{  
      
  // let regularExp = /^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|gmail|yahoo|outlook)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;
  let regularExp = /^([\w.-]+)@((?!hotmail|gmail|yahoo|outlook)([a-zA-Z\d-]+\.)+)([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;
    
      if(control.value!==undefined && !regularExp.test(control.value)){  
        return {"isValidEmail":true};  
      }  
      return null;  
  } 

@Component({
  selector: 'app-ebrochure',
  templateUrl: './ebrochure.component.html',
  styleUrls: ['./ebrochure.component.css']
})
export class EbrochureComponent implements OnInit {

  @ViewChild('closebutton') closebutton: any;
  demoForm: FormGroup;
  innerWidth: number = window.innerWidth;
  demoSubmitted = false;
  cilentIPAddress = '';
  currentRoutePath: any;
  countbrochure: any;

  heading = "E-Brochure";
  subheading = "";
  constructor(private fb: FormBuilder, private http: HttpClient, private httpService: HttpService) {

    this.httpService.getIPAddress().subscribe((res: any) => {
      this.cilentIPAddress = res.ip;
    });

    this.demoForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$'), ValidateEmail])],
      name: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.pattern('^[A-Za-z ]+$')])],
      phonenumber: ['', Validators.compose([Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")])],
      company: ['', Validators.compose([Validators.required])],
      designation: ['', Validators.compose([Validators.required])],
      ebroucherproduct: [''],
    });
  }

  ngOnInit(): void {
  }

  get getDemoForm() {
    return this.demoForm.controls;
  }


  submitDemoForm() {

    let url = environment.API_URL + "ebroucherdetails";
    let urlValue = "";
    this.demoSubmitted = true;
    if (this.demoForm.invalid) {
      return;
    } else {
      if (url.includes("dev.website")) {
        urlValue = "nonprod"
      } else {
        urlValue = "prod"
      }
      var demoData = {
        name: this.demoForm.get('name')!.value,
        email: this.demoForm.get('email')!.value,
        phonenumber: this.demoForm.get('phonenumber')!.value,
        company: this.demoForm.get('company')!.value,
        designation: this.demoForm.get('designation')!.value,
        ebroucherproduct: this.countbrochure,
        ipaddress: this.cilentIPAddress,
        // weburl: urlValue,
        // adcampurl: this.currentRoutePath
      };
      let data = {
        broucherDtls: demoData,
      }
      let encryptMsg = JSON.stringify(data);
      let encMsg = this.httpService.encryptText(encryptMsg, HttpService.SECRET_KEY);
      let postData = {
        encryptedRequest: encMsg
      }

      this.httpService.postAPIMethod(url, postData).subscribe(
        res => {
          let decRes = this.httpService.decryptText(res, HttpService.SECRET_KEY);
          let decMsg = decRes;
          let resp: any = JSON.parse(decMsg);
          alert(resp['statusDesc']);
          // this.subRespData = JSON.parse(decMsg);
          this.downloadMyFile(this.countbrochure);
        },
        error => {
        });
      // console.log("Payload", demoData);
      // this.downloadMyFile(this.countbrochure);
      this.demoSubmitted = false;
      // alert("Request has been submitted..");
      this.closebutton.nativeElement.click();
    }
  }


  onResize(event: any) {
    this.innerWidth = event.target.innerWidth;
  }

  onReset() {
    this.demoForm.reset();
    this.demoSubmitted = false;
  }

  brochurecount(count: any) {
    this.countbrochure = count;
  }

  downloadMyFile(countofbrochure: any) {
    const link = document.createElement('a');
    if (countofbrochure == 'appprotectt') {
      link.setAttribute('href', '../../../assets/brochure/AppProtectt1_lowres_10-02-2023.pdf');
      link.setAttribute('download', `AppProtectt1_lowres_10-02-2023.pdf`);
    } else if(countofbrochure == 'protectt.aicorporatebrochure'){
      link.setAttribute('href', '../../../assets/brochure/Protectt.ai Corporate1_lowres_10-02-2023.pdf');
      link.setAttribute('download', `Protectt.ai Corporate1_lowres_10-02-2023.pdf`);
    } else {
      return;
    }
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

}
